module.exports = __webpack_public_path__ + "img/ico_payment_on.89788c10.svg";